import { lazy } from 'react';

export const Race = lazy(() => import('./Race.component'));
